<template>
  <!-- <v-infinite-scroll :loading="loading" @top="prevPage" @bottom="nextPage" :offset='20' style="max-height: 80vh; overflow-y: scroll;"> -->
  <div>
    <!-- <v-progress-linear
      :size="50"
      color="primary"
      :indeterminate="loading"
    ></v-progress-linear> -->
    <v-infinite-scroll 
      :loading="loading" 
      :offset="20" 
      style="max-height: 100%; overflow-y: scroll;" 
      @bottom="nextPage">
      <v-container 
        fluid 
        grid-list-md>
        <v-layout 
          row 
          wrap>
          <v-flex 
            v-for="item in localizedPortfolioItems" 
            :key="item.id"
            xs12
            sm6
            md4
            lg4
            style="max-height: 100%"
          >
            <portfolio-item :item="item"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container 
        fluid 
        grid-list-md>
        <v-expansion-panel>
          <v-expansion-panel-content>
            <template v-slot:header>
              <div class="title"><v-icon>archive</v-icon> {{ $t("archived_projects") }} <span class="subheading">{{ $t("archived_projects_description") }}</span></div>
            </template> 
            <v-container 
              fluid 
              grid-list-md>
              <v-layout 
                row 
                wrap>
                <v-flex 
                  v-for="item in archivedLocalizedPortfolioItems" 
                  :key="item.id"
                  xs12
                  sm6
                  md4
                  lg4
                  style="max-height: 100%"
                >
                  <portfolio-item :item="item"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-container>
    </v-infinite-scroll>
  </div>
  <!-- <v-data-iterator
      :items="localizedPortfolioItems"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      content-tag="v-layout"
      row
      wrap
    >
      <v-flex
        slot="item"
        slot-scope="props"
        xs12
        sm6
        md4
        lg6
      style="max-height: 100%">
    <portfolio-item :item="props.item" :key="props.item.id"></portfolio-item>
      </v-flex>
    </v-data-iterator> -->
</template>

<script>
  import axios from 'axios';
  import PortfolioItem from "../components/PortfolioItem.vue";
  import InfiniteScroll from 'v-infinite-scroll';
  import 'v-infinite-scroll/dist/v-infinite-scroll.css';
  export default {
    components: {
      'portfolio-item': PortfolioItem,
      'v-infinite-scroll': InfiniteScroll
    },
    data: () => ({
      portfolioItemLangs: [],
      archivedPortfolioItemLangs: [],
      rowsPerPageItems: [9, 12, 15],
      pagination: {
        rowsPerPage: 9
      },
      loading: false,
      items: [],
      page: 0
    }),
    computed: {
      localizedPortfolioItems: function () {
        if (!this.portfolioItemLangs || this.portfolioItemLangs.length === 0) {
          return [];
        }
        var res = this.portfolioItemLangs.find(l => l.lang === this.$i18n.locale);
        if(!res || !res.lang) {
          // return this.setPlacholderImgs(res.portfolioItems);
          res = this.portfolioItemLangs.find(l => l.lang === this.$i18n.fallbackLocale);
        }
        if(!res || !res.lang) {
          return [];
        }
        return res.portfolioItems.slice(0, (this.page*this.pagination.rowsPerPage)+this.pagination.rowsPerPage);
      },
      archivedLocalizedPortfolioItems: function () {
        if (!this.archivedPortfolioItemLangs || this.archivedPortfolioItemLangs.length === 0) {
          return [];
        }
        var res = this.archivedPortfolioItemLangs.find(l => l.lang === this.$i18n.locale);
        if(!res || !res.lang) {
          // return this.setPlacholderImgs(res.portfolioItems);
          res = this.archivedPortfolioItemLangs.find(l => l.lang === this.$i18n.fallbackLocale);
        }
        if(!res || !res.lang) {
          return [];
        }
        return res.portfolioItems.slice(0, (this.page*this.pagination.rowsPerPage)+this.pagination.rowsPerPage);
      }
    },
    mounted() {
      this.getPortfolioLangs();
      this.api();
    },
    methods: {
      getPortfolioLangs() {
        let that = this;
        Object.keys(this.$i18n.messages).map((key) => {
          axios.get('/data/PortfolioItems/' + key + '.json').then(function (response) {
            that.portfolioItemLangs.push({ lang: key, portfolioItems: response.data })
          });
          axios.get('/data/PortfolioItems/archived/' + key + '.json').then(function (response) {
            that.archivedPortfolioItemLangs.push({ lang: key, portfolioItems: response.data })
          });
        });
      },
      setPlacholderImgs(items) {
        items.forEach((item => {
          item.thumbnail = 'https://loremflickr.com/400/150/'+item.name+'?lock=0';
          item.images = [];
          for (let i = 0; i < 3; i++) {
            item.images.push('https://loremflickr.com/500/300/'+item.name+'?lock='+i);
          }
        }));
        return items;
      },
      prevPage () {
        if (this.page == 1) return
          --this.page
        this.api()
      },
      nextPage () {
        ++this.page
        this.api()
      },
      api () {
        // this.loading = true
        // new Promise(r => setTimeout(r, 1000)).then(() => {
        //     this.items = this.localizedPortfolioItems;
        //     this.loading = false
        //   });
        // myApi.get({page: this.page}).then((response) => {
          
        // })
      }
    },
  }
</script>